import React from 'react';
import OrangeCheckIcon from '@repo/ui/src/components/Icons/OrangeCheck';

interface Props {
  salesforceValue: string | boolean;
}
const Value = ({ salesforceValue }: Props) =>
  typeof salesforceValue === 'boolean' ? (
    salesforceValue ? (
      <OrangeCheckIcon />
    ) : (
      <svg
        xmlns=" http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clip-path="url(#clip0_315_2682)">
          <path
            d="M5.75999 5.75977L18.24 18.2398M18.24 5.75977L5.75999 18.2398"
            stroke="#727170"
            stroke-width="2"
            stroke-linecap="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_315_2682">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  ) : (
    <p className="tra-text-web-body-l">{salesforceValue}</p>
  );

export default Value;
